// extracted by mini-css-extract-plugin
module.exports = {"separatorLight":"separators_separatorLight__2mLfQ","separatorNew":"separators_separatorNew__2B0IK"};